import React, { useState } from "react";
import "./GroupPolicyForm.scss";
import SelfForm from "./Forms/SelfForm";
import AdvisorForm from "./Forms/AdvisorForm";
import OtherCustomerForm from "./Forms/OtherCustomerForm";
const tabs = [
  { id: 1, label: "Self", value: "SELF" },
  { id: 2, label: "Advisor", value: "ADVISOR" },
  { id: 3, label: "Any Other Customer", value: "OTHER" },
];
const GroupPolicyForm = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].value);

  const handleTabs = (tab) => {
    setActiveTab(tab.value);
  };

  const formMap = {
    SELF: <SelfForm />,
    ADVISOR: <AdvisorForm />,
    OTHER: <OtherCustomerForm />,
  };
  const renderForm = (activeTab) => formMap[activeTab] || null;
  return (
    <div className="group-policy-wrapper">
      <div className="group-tab">
        <div className="group-tab__left">
          <div className="group-tab__left__wraper">
            <h6>For Group Policy Customers</h6>
            <h3 className="bold">Please select the category of your concern</h3>
            <div className="group-tab-form">
              {tabs.map((tab) => (
                <div key={tab.id} className="tabsitem-wraper">
                  <div
                    className={`tabs-item ${
                      activeTab === tab.value ? "active" : ""
                    }`}
                    onClick={() => handleTabs(tab)}
                  >
                    {tab.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="group-tab__right">
          <div className="group-tab__right__wraper">
            <div className="top-header">
              <h6 className="small-body regular">
                If you are an employee of the IndusInd Group, you can post your
                policy-related concerns here.
              </h6>
              <h4 className="bold">Write to us</h4>
            </div>
            <div className="form-dropzon">{renderForm(activeTab)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupPolicyForm;
